import React, { createContext, useState, useContext, useEffect } from 'react';

const UIContext = createContext();

// The screen width below which we consider the layout "mobile"
const MOBILE_BREAKPOINT = 768; 

export const UIProvider = ({ children }) => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

    // Effect to handle window resizing
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < MOBILE_BREAKPOINT;
            setIsMobile(mobile);
            // Automatically collapse the sidebar when switching to mobile view
            if (mobile) {
                setIsSidebarCollapsed(true);
            }
        };

        window.addEventListener('resize', handleResize);
        // Clean up the event listener when the component unmounts
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSidebar = () => {
        setIsSidebarCollapsed(prevState => !prevState);
    };

    const value = { isSidebarCollapsed, toggleSidebar, isMobile };

    return (
        <UIContext.Provider value={value}>
            {children}
        </UIContext.Provider>
    );
};

export const useUI = () => {
    return useContext(UIContext);
};